module.exports = __webpack_public_path__ + "img/img35.2bc6972a.png";